import { BidHistorySection } from '../../../../Shared/VehicleDetails/components';
import { useViewedVehicle } from '../../hooks/useViewedVehicle';
import { InfoBlock } from '../InfoBlock';
import { AUCTION_TYPES } from 'constants';
import { convertToLocalTime } from 'utils';
import { useShouldHistorySectionRender } from './useShouldHistorySectionRender';
import { AABids } from './aaBidHistory';
import { AAOffers } from './aaOfferHistory';
import { AlternativeOffers } from './alternativeOfferHistory';

export const BidsHistory = () => {
  const vehicle = useViewedVehicle();
  const { bids, offers, alternativeOffers } = useShouldHistorySectionRender();

  if (!vehicle) return null;

  return (
    <>
      {bids.render && <AABids vehicle={vehicle} initiallyCollapsed={bids.collapsed} />}
      {offers.render && <AAOffers vehicle={vehicle} initiallyCollapsed={bids.collapsed} />}
      {alternativeOffers.render && <AlternativeOffers vehicle={vehicle} initiallyCollapsed={bids.collapsed} />}
    </>
  );
};
